import { Poker2Dialog } from "../Poker2Dialog";

import Container = createjs.Container;
import MovieClip = createjs.MovieClip;

export class Poker2AnimDialog extends Poker2Dialog {
    constructor(disp: Container) {
        super(disp);

        if (this.animMovie) {
            this.animMovie.gotoAndStop(1);
        }
    }

    public show(): void {
        super.show();

        if (this.animMovie) {
            this.animMovie.gotoAndPlay(1);
        }
    }

    private get animMovie(): MovieClip {
        if ("mc_anim" in this.disp)
            return (this.disp as MovieClip).mc_anim;
        else
            return null;
    }
}
